import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const SpeakerCard = ({ speaker, topicLabel, index }) => (
  <Reveal
    delay={(index % 3) * 0.06}
    className="group flex h-full flex-col rounded-xl border border-border bg-card p-5 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-elevated"
  >
    <div className="flex items-center gap-4">
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gradient-navy ring-1 ring-gold/40">
        <span className="font-display text-base font-semibold text-primary-foreground">{speaker.initials}</span>
      </div>
      <div className="min-w-0">
        <h3 className="font-display text-lg leading-tight text-primary">{speaker.name}</h3>
        <p className="mt-0.5 text-xs leading-snug text-muted-foreground">{speaker.role}</p>
      </div>
    </div>
    <div className="mt-auto pt-5">
      <div className="border-t border-border pt-4">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-gold-ink">{topicLabel}</p>
        <p className="mt-1.5 text-sm leading-relaxed text-foreground/90 transition-colors group-hover:text-primary">{speaker.topic}</p>
      </div>
    </div>
  </Reveal>
);

export const Speakers = () => {
  const { t } = useI18n();
  const s = t.speakers;
  const groups = [
    { label: s.dayLabel1, list: s.day1 },
    { label: s.dayLabel2, list: s.day2 },
  ];
  let gi = -1;
  return (
    <section id="speakers" className="scroll-mt-24 bg-background">
      <div className="container-site section-pad py-20 md:py-24">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} description={s.desc} />
        <div className="mt-12 space-y-12">
          {groups.map((group) => (
            <div key={group.label}>
              <div className="mb-6 flex items-center gap-4">
                <h3 className="font-display text-xl text-primary">{group.label}</h3>
                <span className="h-px flex-1 bg-border" aria-hidden="true" />
                <span className="whitespace-nowrap rounded-full bg-secondary px-3 py-1 text-xs font-medium text-secondary-foreground">
                  {group.list.length} {s.sessions}
                </span>
              </div>
              <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {group.list.map((speaker) => {
                  gi += 1;
                  return <SpeakerCard key={speaker.name} speaker={speaker} topicLabel={s.topicLabel} index={gi} />;
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
